/**
 * Texts of a business (docs/08-entscheidungen.md, S14): lines on a menu that are no dish, „Tapa del
 * día – Fragen Sie nach unseren Tagestapas!“ or „Letzte Bestellung für die Küche 21 Uhr“. Kept in
 * the catalogue like the dishes and live on every menu (S3), but without number, price or
 * allergens; a menu names a text by its id where it names a dish.
 */
import { uuidv7 } from "./ids.ts";

export interface CardText {
  id: string;
  /** „Tapa del día“; may be empty when there is a text. */
  title: string;
  /** „Fragen Sie nach unseren Tagestapas!“; may be empty when there is a title. */
  body: string;
}

export const TEXT_LIMITS = { title: 120, body: 600, texts: 200 } as const;

const oneLine = (s: unknown) => (typeof s === "string" ? s.normalize("NFC").replace(/\s+/g, " ").trim() : "");

/** What a text shows in a list: its title, else the start of its text. */
export const textLabel = (t: Pick<CardText, "title" | "body">) => t.title || (t.body.length > 60 ? `${t.body.slice(0, 57)}…` : t.body);

/** The whole list as sent by the app, in its order, or what is wrong; new texts get an id. */
export function cleanTexts(input: unknown, at = Date.now()): { value: CardText[] } | { error: string } {
  const list = Array.isArray(input) ? input : [];
  if (list.length > TEXT_LIMITS.texts) return { error: `Höchstens ${TEXT_LIMITS.texts} Textbausteine.` };
  const out: CardText[] = [];
  const ids = new Set<string>();
  for (const [i, raw] of list.entries()) {
    const o = (raw ?? {}) as Record<string, unknown>;
    const title = oneLine(o.title);
    const body = oneLine(o.body);
    if (!title && !body) return { error: `Text ${i + 1}: bitte eine Überschrift oder einen Text angeben.` };
    if (title.length > TEXT_LIMITS.title) return { error: `Text ${i + 1}: die Überschrift ist zu lang (höchstens ${TEXT_LIMITS.title} Zeichen).` };
    if (body.length > TEXT_LIMITS.body) return { error: `Text ${i + 1}: der Text ist zu lang (höchstens ${TEXT_LIMITS.body} Zeichen).` };
    const id = typeof o.id === "string" && /^[\w-]{8,64}$/.test(o.id) && !ids.has(o.id) ? o.id : uuidv7(at + i);
    ids.add(id);
    out.push({ id, title, body });
  }
  return { value: out };
}
